import Plyr from '../../../assets/custom_components/plyr/plyr'

/* @ngInject */
function AssetPreviewVideoController ($scope, $rootScope, $interval, NewAssetService, AssetPreviewService, $attrs, SegmentService) {
  $scope.videoId = $scope.template.id
  $scope.videoPreviewURL = ''
  $scope.navigationOpen = false
  $scope.loading = true

  const api = {
    _getAssetPreviewSrc
  }
  this.getApi = () => api

  const controls = [
    'play',
    'restart',
    'mute',
    'volume',
    'progress',
    'current-time',
    'duration',
    'settings',
    'speed',
    'fullscreen'
  ]

  const settings = [
    'speed'
  ]

  activate()

  function activate () {
    api._getAssetPreviewSrc()
  }

  function _getAssetPreviewSrc (isTemplate) {
    if ($scope.template.videoPreview?.url) {
      $scope.videoPreviewURL = $scope.template.videoPreview?.url

      if ($scope.template?.art_layers?.length) {
        $scope.previewFlags.selectedLayerId = $scope.template.art_layers[0].id
        return
      }

      $scope.previewFlags.selectedLayerId = null
      return
    }

    if (isTemplate) {
      $scope.videoPreviewURL = AssetPreviewService.getArtPreview($scope.videoId, null, { quality: 'ORIGINAL' })
    } else {
      const moduleLocation = AssetPreviewService.getModuleForLocation($scope.location)
      $scope.videoPreviewURL = AssetPreviewService.getAssetPreview($scope.videoId, moduleLocation, { quality: 'ORIGINAL' })
    }
  }

  const deregisterReloadPreview = $rootScope.$on('asset-preview-dialog.reload-preview-details', () => {
    $scope.videoId = $scope.template?.id
    const isTemplate = $scope.template?.assetId !== $scope.template?.id

    const interval = $interval(() => {
      NewAssetService.checkAssetHasThumb($scope.template.id, 'HIGH').then((hasThumb) => {
        if (!hasThumb) {
          return
        }

        $interval.cancel(interval)
        $rootScope.$emit(`asset-card-${$scope.template.id}.update-asset-thumbnail`)
      })
    }, 8000)

    api._getAssetPreviewSrc(isTemplate)
    $scope.player?.destroy() // eslint-disable-line no-unused-expressions
    $scope.initVideoPlayer()
  })

  $scope.$on('$destroy', () => {
    deregisterReloadPreview()
    $scope.previewFlags.videoPlayer = null
  })

  $scope.$watchCollection('template', () => {
    $scope.navigationOpen = true
    $scope.videoId = $scope.template?.id
    const isTemplate = $scope.template?.assetId !== $scope.template?.id

    api._getAssetPreviewSrc(isTemplate)
    $scope.player?.destroy() // eslint-disable-line no-unused-expressions
    $scope.initVideoPlayer()
  })

  $scope.initVideoPlayer = function () {
    const playerElement = $attrs.$$element.find('[data-preview="video"]')[0]
    $scope.player = new Plyr(playerElement, { controls, settings })

    $scope.player.on('canplay', (event) => {
      $scope.previewFlags.videoCanPlay = true
      const video = event.currentTarget.querySelector('video')

      $scope.$apply(() => {
        if (video.readyState >= 3) {
          $scope.loading = false
        }
      })
    })

    $scope.player.on('pause', () => {
      SegmentService.track('arts-preview-interact', { interact_type: 'stop', type: 'upload' })
    })

    $scope.player.on('playing', () => {
      SegmentService.track('arts-preview-interact', { interact_type: 'play', type: 'upload' })

      $scope.previewFlags.videoPin = null
    })

    $scope.player.source = {
      type: 'video',
      sources: [
        {
          src: $scope.videoPreviewURL,
          type: 'video/mp4'
        }
      ]
    }

    $scope.previewFlags.videoPlayer = $scope.player
  }

  $scope.annotationMouseEnter = (pin) => {
    $scope.previewFlags.hoverCommentId = pin.approvalCommentId || pin.assetCommentId
  }

  $scope.annotationMouseLeave = () => {
    $scope.previewFlags.hoverCommentId = null
  }
}

export { AssetPreviewVideoController }
